// extracted by mini-css-extract-plugin
export default {"products":"CB-z","card":"DB-z","oosMessaging":"EB-z"};